import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `GrupoVerraco/getCambiarEstadoSeleccion`, method: 'POST', body: {list}, token: token})
}